import React, { lazy, Suspense, useEffect, useMemo } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { useTenant } from './Common/Contexts/TenantContext';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import WebsiteVisualizer from './WebsiteVisualizer';
import WebsiteManager from './WebsiteManager';
import SEOManager from './Common/SEO/SEOManager';

// Template Loaders
const templateLoaders = {
  Template_1: () => import('./Templates/Template_1'),
  Template_2: () => import('./Templates/Template_2'),
  Template_3: () => import('./Templates/Template_3'),
  Template_4: () => import('./Templates/Template_4'),
  Template_8: () => import('./Templates/Template_8'),
  Template_21: () => import('./Templates/Template_21'),
  Template_31: () => import('./Templates/Template_31'),
  Template_32: () => import('./Templates/Template_32'),
  Template_33: () => import('./Templates/Template_33'),
  Template_34: () => import('./Templates/Template_34'),
  Template_35: () => import('./Templates/Template_35'),
  Template_36: () => import('./Templates/Template_36'),
  Template_37: () => import('./Templates/Template_37'),
  Template_38: () => import('./Templates/Template_38'),
  Template_39: () => import('./Templates/Template_39'),
  Template_40: () => import('./Templates/Template_40'),
  Template_41: () => import('./Templates/Template_41'),
  Template_42: () => import('./Templates/Template_42'),
  Template_43: () => import('./Templates/Template_43'),
  Template_44: () => import('./Templates/Template_44'),
  Template_45: () => import('./Templates/Template_45'),
  Template_61: () => import('./Templates/Template_61'),
  Template_62: () => import('./Templates/Template_62'),
  Template_63: () => import('./Templates/Template_63'),
  //ForDmc  only packages&activities displaying in Template_70
  Template_70: () => import('./Templates/Template_70'),
  Template_71: () => import('./Templates/Template_71'),
};

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function DynamicTemplate({ templateReference }) {

  const ActiveTemplate = useMemo(() => {

    const loader = templateLoaders[templateReference];

    if (!loader)
      return null;

    return lazy(loader);

  }, [templateReference]);

  if (!ActiveTemplate) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
        <div className="text-center p-5 shadow-sm bg-white rounded-4" style={{ maxWidth: 400 }}>
          <h1 className="display-4 text-muted mb-3">404</h1>
          <h5 className="fw-bold">Website Not Configured</h5>
          <p className="text-secondary small">
            This domain is not associated with an active template.
          </p>
          <hr />
          <small className="text-muted">© 2026 Smart Travel Platform</small>
        </div>
      </div>
    );
  }

  return (
    <Suspense
      fallback={
        <div className="d-flex justify-content-center align-items-center vh-100">
          <div className="spinner-border text-primary" role="status"></div>
        </div>
      }
    >
      <ActiveTemplate />
    </Suspense>
  );
}

function App() {

  const { tenantData, loading } = useTenant();

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinner-border text-primary" role="status"></div>
      </div>
    );
  }

  return (
    <>
      <ScrollToTop />

      <SEOManager />

      <Routes>

        <Route
          path="/admin/website-manager"
          element={<WebsiteManager />}
        />

        <Route
          path="/admin/website-visualizer"
          element={<WebsiteVisualizer />}
        />

        <Route
          path="*"
          element={
            <DynamicTemplate
              templateReference={tenantData?.templateReference}
            />
          }
        />

      </Routes>

      <ToastContainer
        position="top-right"
        autoClose={3000}
      />
    </>
  );
}

export default App;